import { loadStripe } from "@stripe/stripe-js";

// Singleton Stripe instance for embedded Elements (Step 39 /subscribe).
let promise = null;
export function getStripe() {
  if (!promise) {
    promise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);
  }
  return promise;
}

export const fmtPrice = (n) => {
  if (n == null) return "";
  return `$${Number(n).toFixed(2)}`;
};
